import './home.css';
import './create.css';

import styled from '@emotion/styled';
import CloseIcon from '@mui/icons-material/Close';
import { Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { API } from '../actions/userAction';
import { URL, FURL } from '../constants/userConstants';
import { getImgurl } from '../utils/img_url';
import Loader from './loader';
import { useSelector } from 'react-redux';

const Container = styled.div`
  background-image: url('${FURL}/pitch.png');
  width: 100%;
  min-height: 100vh;
  padding: 20px 10px;

  display: flex;
  flex-direction: column;

  gap: 20px;   // 🔥 spacing control
  font-family: "Open Sans";
`;
const Heading = styled.h3`
  color:#FFF;
  text-align:center;
  text-transform:uppercase;
`;

const PlayerP = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  height:100px;
`;

const Title = styled.h3`
  position: absolute;
  bottom: -10px;
  background-color: black;
  color: #ffffff;
  padding: 1px 5px;
  border-radius: 5px;
  font-size: 12px;
`;

const AwayTitle = styled.h3`
  position: absolute;
  bottom: -10px;
  background-color: white;
  color: #212121;
  padding: 1px 5px;
  border-radius: 5px;
  font-size: 12px;
`;

const Images = styled.div`
  position: relative;
  display:flex;
  justify-content:center;
  align-items:center;
  transform: scale(1);
`;

const PImage = styled.img`
  width: 60px;
  height: 50px;
`;
export function SavedTeam() {
  const navigate = useNavigate();
  const { match_details, matchlive } = useSelector((state) => state.match);
  const { user } = useSelector((state) => state.user);
  const { id } = useParams();
  const [players, setPlayers] = useState(null);

  useEffect(() => {
    if (!user?._id) return;

   async function getteam() {
  try {
    const teamRes = await API.get(`${URL}/getteam/${id}?uidfromtoken=${user._id}`);

    const teamData = teamRes.data; // ✅ FIX

   if (!teamData?.players) {
  setPlayers([]);
  return;
}

    function gethome(pid) {
      return !!match_details?.teamHomePlayers.find(h => h.playerId == pid);
    }

    const mergedPlayers = teamData.players.map((p) => {
      const homePlayer = matchlive?.teamHomePlayers?.find(lp => lp.playerId == p.playerId);
      const awayPlayer = matchlive?.teamAwayPlayers?.find(lp => lp.playerId == p.playerId);

      let points = p.point || homePlayer?.points || awayPlayer?.points || 0;

      if (teamData.captainId == p.playerId) points *= 2;
      if (teamData.viceCaptainId == p.playerId) points *= 1.5;

      return {
        ...p,
        points,
        role: normalizeRole(p.position), // 🔥 ये add किया
        isHome: gethome(p.playerId),
        isCaptain: teamData.captainId == p.playerId,
        isViceCaptain: teamData.viceCaptainId == p.playerId,
      };
    });

    setPlayers(mergedPlayers);

  } catch (err) {
    console.log("ERROR:", err);

    if (err.response?.status === 403) {
      alert("🔒 Team Locked");
      navigate(-1);
    }
  }
}

    getteam();
  }, [id, match_details, matchlive]);

  const normalizeRole = (pos) => {
  if (!pos) return "BAT";

  pos = pos.toLowerCase();

  if (pos.includes("wk") || pos.includes("keeper")) return "WK";
  if (pos.includes("bat")) return "BAT";
  if (pos.includes("all")) return "AR";
  if (pos.includes("bowl")) return "BOWL";

  return "BAT";
};

  const renderPlayer = (p) => (
    <PlayerP>
      <Images>
        <PImage src={getImgurl(p.image)} />

        {/* C */}
        {p.isCaptain && (
          <div style={{
            position: "absolute",
            top: "-6px",
            left: "-6px",
            background: "orange",
            color: "white",
            fontSize: "10px",
            width: "18px",
            height: "18px",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}>C</div>
        )}

        {/* VC */}
        {p.isViceCaptain && (
          <div style={{
            position: "absolute",
            top: "-6px",
            right: "-6px",
            background: "blue",
            color: "white",
            fontSize: "10px",
            width: "18px",
            height: "18px",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}>VC</div>
        )}
      </Images>

      {p.isHome
        ? <Title>{p.playerName.split(' ')[1] || p.playerName}</Title>
        : <AwayTitle>{p.playerName.split(' ')[1] || p.playerName}</AwayTitle>
      }

      <div style={{
        position: "absolute",
        bottom: "-28px",
        color: "yellow",
        fontSize: "12px"
      }}>
        {p.points} pts
      </div>
    </PlayerP>
  );
const wk = players?.filter(p => p.role === "WK") || [];
const bat = players?.filter(p => p.role === "BAT") || [];
const ar = players?.filter(p => p.role === "AR") || [];
const bowl = players?.filter(p => p.role === "BOWL") || [];

  return (
    <div>
      {players ? (
        <Container>

          <div style={{ position:'fixed', top:20, right:20 }}>
            <CloseIcon onClick={() => navigate(-1)} />
          </div>

<Heading>WK</Heading>
<div style={{
  display: "flex",
  justifyContent: "center",
  flexWrap: "wrap",
  gap: "12px"
}}>
  {wk.map(p => (
    <div
      key={p.playerId}
      style={{
        width: wk.length <= 3 ? "30%" : wk.length <= 6 ? "22%" : "16%",
        display: "flex",
        justifyContent: "center"
      }}
    >
      {renderPlayer(p)}
    </div>
  ))}
</div>

<Heading>BAT</Heading>
<div style={{
  display: "flex",
  justifyContent: "center",
  flexWrap: "wrap",
  gap: "12px"
}}>
  {bat.map(p => (
    <div
      key={p.playerId}
      style={{
        width: bat.length <= 3 ? "30%" : bat.length <= 6 ? "22%" : "16%",
        display: "flex",
        justifyContent: "center"
      }}
    >
      {renderPlayer(p)}
    </div>
  ))}
</div>

<Heading>AR</Heading>
<div style={{
  display: "flex",
  justifyContent: "center",
  flexWrap: "wrap",
  gap: "12px"
}}>
  {ar.map(p => (
    <div
      key={p.playerId}
      style={{
        width: ar.length <= 3 ? "30%" : ar.length <= 6 ? "22%" : "16%",
        display: "flex",
        justifyContent: "center"
      }}
    >
      {renderPlayer(p)}
    </div>
  ))}
</div>

<Heading>BOWL</Heading>
<div style={{
  display: "flex",
  justifyContent: "center",
  flexWrap: "wrap",
  gap: "12px"
}}>
  {bowl.map(p => (
    <div
      key={p.playerId}
      style={{
        width: bowl.length <= 3 ? "30%" : bowl.length <= 6 ? "22%" : "16%",
        display: "flex",
        justifyContent: "center"
      }}
    >
      {renderPlayer(p)}
    </div>
  ))}
</div>

        </Container>
      ) : <Loader />}
    </div>
  );
}

export default SavedTeam;
